// src/api/website-api/web.login.js
import axios from "axios";

const WEB_LOGIN_URL =
  `${process.env.REACT_APP_API_POS_WITH_WEBSITE}/api/vendor/jwt/create/`;

/**
 * Vendor login via website API
 * @param {Object} params
 * @param {string|number} params.storeId
 * @param {string} params.email
 * @param {string} params.password
 */
export const webLogin = async ({ storeId, email, password }) => {
  const payload = {
    store_id: storeId,
    email,
    password,
  };

  const { data } = await axios.post(WEB_LOGIN_URL, payload, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Normalize backend → frontend contract
  // DRF SimpleJWT usually returns: { access, refresh }
  const access =
    data?.access || // SimpleJWT
    data?.token ||  // custom
    data?.accessToken;

  const refresh =
    data?.refresh ||
    data?.refresh_token ||
    data?.refreshToken ||
    "";

  const userId =
    data?.user?.id ??
    data?.user_id ??
    data?.userId ??
    null;

  if (!access) {
    console.error("webLogin: invalid auth response", data);
    throw new Error("Invalid token response from server");
  }

  // 🚨 From now on, Signin will ALWAYS get { token, refreshToken, userId }
  return {
    token: access,
    refreshToken: refresh,
    userId,
  };
};
